import { useEffect } from 'react'
import { useAuth } from '../auth'
import { useToasts } from '../../components/complex/Toast'
import { t } from '../i18n'

interface UsePcoAuthMessageHandlerOptions {
  onAuthSuccess?: () => void
}

/**
 * Custom hook to handle PCO OAuth postMessage events
 * Listens for PCO_AUTH_SUCCESS and PCO_AUTH_ERROR messages from the backend
 */
export const usePcoAuthMessageHandler = (
  options: UsePcoAuthMessageHandlerOptions = {}
) => {
  const { refetchCurrentUser } = useAuth()
  const { addToast } = useToasts()
  const { onAuthSuccess } = options

  useEffect(() => {
    function handleMessage(event: MessageEvent) {
      try {
        const backendOrigin = new URL(process.env.NEXT_PUBLIC_OLD_URL).origin

        if (event.origin !== backendOrigin) {
          return
        }
      } catch (error) {
        console.warn('Failed to parse backend URL for origin check:', error)
        return
      }

      if (event.data?.type === 'PCO_AUTH_SUCCESS') {
        addToast(
          t(
            'You successfully connected your Planning Center Online account. You can now add songs to your PCO account.'
          ),
          'primary'
        )
        refetchCurrentUser()
        onAuthSuccess?.()
      } else if (event.data?.type === 'PCO_AUTH_ERROR') {
        const errorMessage =
          event.data.message ||
          t(
            'Failed to connect your Planning Center Online account. Please try again.'
          )
        addToast(errorMessage, 'danger')
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [addToast, refetchCurrentUser, onAuthSuccess])
}
